function textColor(hexColor) {
  if (typeof hexColor !== 'string') {
    return '#000000';
  }

  hexColor = hexColor.replace('#', '');
  const r = parseInt(hexColor.substr(0, 2), 16);
  const g = parseInt(hexColor.substr(2, 2), 16);
  const b = parseInt(hexColor.substr(4, 2), 16);
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;
  return yiq >= 132 ? '#000000' : '#ffffff';
}

export default textColor;
